import Vue from "vue/dist/vue.js";
import Bookings from "./Bookings.vue";

/**
 * @title Rates Form Add/Remove
 * @description Add / Remove Blocks
 */

const bookings = () => {
	const bookings = document.querySelector("#rink-booking");
	if (document.body.contains(bookings)) {
		new Vue({
			el: "#rink-booking",
			template: "<Bookings/>",
			components: { Bookings },
		});
	}
};

export { bookings };
